import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button
} from "reactstrap"
import { Link, useHistory, useParams } from "react-router-dom"
import { withRouter } from "react-router";
import { Preview } from '../../../../helpers/ui/FileInput'
import apiResponse from '../../../../services/apiResponse'
import moment from 'moment';
import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar';

import DetailBloc from './Blocs/DetailBloc'

class IndexView extends Component {

    detailBloc = new DetailBloc()

    constructor(props) {
        super(props)
        this.state = {
        }
    }

    dateParse = (input) =>{
        let res = "-";
        if (input != "" && input != null){
            res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    rupiah = (num) => {
        let res = "-";
        if (num != null && num != ''){
            res = parseFloat(num).toLocaleString('id-ID', {maximumFractionDigits:2})
        }
        return res;
    }

    componentDidMount() {
        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({
                            detail: response,
                            document: response.document_sk
                        })
                        //console.log(response)
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)
        this.detailBloc.fetchDetail({uuid: queryParams.get('uuid') })
    }

    componentWillUnmount(){
        this.detailBloc.detailChannel.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <PegawaiSideBar active="riwayat_gaji"/>

                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <CardTitle>Detail Riwayat Gaji</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Informasi Detail Riwayat Gaji
                                    </CardSubtitle>
                                    <hr />

                                     <Row className="mb-3">
                                        <label className="col-md-4">
                                        Gaji
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.kgb_salary_value !== "" ? this.rupiah(this.state.detail.kgb_salary_value) : '-'}</>
                                                : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-4">
                                        Pangkat Golongan/Ruang
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.rank_group_room !== "" ? this.state.detail.rank_group_room : '-'}</>
                                                : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-4">
                                        Nomor SK
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.kgb_sk_number !== "" ? this.state.detail.kgb_sk_number : '-'}</>
                                                : <Shimmer><div style={{width: 200, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-4">
                                        Tanggal SK
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.kgb_sk_date !== "" ? this.dateParse(this.state.detail.kgb_sk_date) : '-'}</>
                                                : <Shimmer><div style={{width: 200, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-4">
                                        TMT
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.kgb_tmt_sk_date !== "" ? this.dateParse(this.state.detail.kgb_tmt_sk_date) : '-'}</>
                                                : <Shimmer><div style={{width: 200, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-4">
                                        Jenis Kenaikan Gaji
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.kgb_source_type_name !== "" ? (this.state.detail.kgb_source_type_name) : '-'}</>
                                                : <Shimmer><div style={{width: 200, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-4">
                                            File SK KGB
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.document ?
                                                    <>
                                                        {this.state.document !== null ?  
                                                            <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.document?.documents_path}>
                                                                Download <i className="fa fa-download ms-1"></i>
                                                            </a>
                                                        : '-'}
                                                    </>
                                                :
                                                    // <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                    "-"
                                            }
                                        </Col>
                                    </Row>
                                   
                                    <Row className="mb-3">
                                        <Col md="3"></Col>
                                        <Col md="8">
                                            <Link to="/kepegawaian/home.html?riwayat_gaji" className="waves-effect">
                                                <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                            </Link>
                                        </Col>
                                    </Row>
                                    
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }
}

//export default IndexView
export default withRouter(IndexView);